import React, { useState, useEffect, useMemo, useRef } from "react";
import { NavLink } from "react-router-dom";
import { Grid, TextField, LinearProgress, Button } from "@mui/material";
import ReactPaginate from "react-paginate";
// COMPONENTS
import Table from "../../Components/Common/Table/Table";
// FUNCTIONS
import {
  CommonSubHeader,
  getInfoMessageNoResultsSearch,
} from "../../Components/helpers/Helpers";
import TableActions from "../../Components/Common/Table/TableActions";
import { Fax, Keyboard } from "@mui/icons-material";
import api from "../../api/axios";

function Offices({
  flagToShow = true,
  setCompanyFromUser = false,
  setOfficesControlNumber,
}) {
  const mountedRef = useRef(true);

  // Estados principales
  const [offices, setOffices] = useState([]);
  const [objPerPage, setObjPerPage] = useState(10);
  const [totalPagesNumber, setTotalPagesNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pagePressed, setPagePressed] = useState(1);
  const [loading, setLoading] = useState(false);
  const [changeDone, setChangeDone] = useState(false);

  // Obtener datos
  const getDataOffices = async () => {
    setLoading(true);

    console.log(setCompanyFromUser);

    try {
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/offices`,
        {
          page: pagePressed,
          objPerPage,
          ...(setCompanyFromUser && { company_id: setCompanyFromUser }),
        },
      );

      if (setCompanyFromUser) {
        setOfficesControlNumber(data?.offices?.total);
      }

      console.log(data);

      const { data: officesData, total, last_page } = data.offices;
      updateState(officesData, total, last_page);
    } catch (error) {
      console.error("Error en la respuesta del servidor:", error);
    } finally {
      setLoading(false); // Asegúrate de restablecer el estado de carga
    }
  };

  // Función para actualizar el estado
  const updateState = (officesData, total, lastPage) => {
    setOffices(officesData);
    setTotalPagesNumber(total);
    setPageCount(lastPage);
  };

  useEffect(() => {
    getDataOffices();
  }, [pagePressed]);

  const handlePageClick = (event) => {
    setPagePressed(event.selected + 1);
  };

  const renderLogoCell = (value) => (
    <div className="spanClassForTables centerContent">
      {ImageCell(value) || "Sin asignar"}
    </div>
  );

  const ImageCell = (value) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        justifyContent: "center",
      }}>
      <img
        src={`${process.env.REACT_APP_BACKEND_HOST}/storage/company/${value.id}/${value.company_logo}`}
        alt="Company logo"
        style={{ height: "30px" }}
      />
      <b>{value.company_name}</b>
    </div>
  );

  // Componente de Despacho
  const OfficeNameCell = ({ value }) => (
    <div className="spanClassForTables centerContent">{value}</div>
  );

  // Componente de CIF
  const CifCell = ({ value }) => (
    <div className="spanClassForTables centerContent">
      {value || "Sin asignar"}
    </div>
  );

  const columns = useMemo(
    () => [
      {
        Header: "LISTA DE DESPACHOS",
        columns: [
          {
            Header: "Logo",
            accessor: "company_relation",
            Cell: ({ value }) => renderLogoCell(value),
          },
          { Header: "Despacho", accessor: "office_name", Cell: OfficeNameCell },
          { Header: "CIF", accessor: "office_cif", Cell: CifCell },
          {
            Header: "Ver/editar",
            accessor: "id",
            Cell: ({ value }) => (
              <TableActions
                rute={"despachos"}
                value={value}
                showEdit
                showView
                module="office"
                apiRute="offices"
                setChangeDone={setChangeDone}
                changeDone={changeDone}
              />
            ),
          },
        ],
      },
    ],
    [],
  );

  useEffect(() => {
    if (pagePressed > pageCount) {
      setPagePressed(1);
    }
  }, [pageCount]);

  const content = (
    <div className="fatherContainer">
      <div className="mainContainer">
        <div className="subMainContainer">
          {loading && <LinearProgress color="success" />}
          <Table
            columns={columns}
            data={offices}
            view="despacho"
            viewTitle="despachos"
            totalPagesNumber={totalPagesNumber}
            tableWidth={"unset"}
            icon={Fax}
            minTableWidth={"90%"}
          />
          {totalPagesNumber > 10 && (
            <div className="tablePaginateContainer">
              <div className="paginatorLeftText">
                Mostrando {objPerPage * (pagePressed - 1) + 1} a{" "}
                {Math.min(objPerPage * pagePressed, totalPagesNumber)} de{" "}
                {totalPagesNumber} resultados
              </div>
              <ReactPaginate
                breakLabel="..."
                nextLabel="Siguiente 🢂"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="🢀 Anterior"
                containerClassName="pagination"
                activeClassName="active"
                pageClassName="page-item"
                nextClassName="page-item"
                previousClassName="page-item"
                disabledClassName="disabled"
                forcePage={pagePressed - 1}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <>
      {flagToShow ? (
        <CommonSubHeader title="Configuración" subTitle="Despachos" />
      ) : null}
      {content}
    </>
  );
}

export default Offices;
